
import axios from '../../helpers/axios';


export const updatedMainPage = (id, updateMainPage) => axios.patch(`/mainPage/update/${id}`, updateMainPage)
// export const deletedHeader = (id) => axios.delete(`/header/deleteHeader/${id}`)
